import {camelCase, mapValues} from 'lodash';
import {parseString as xmlParseString} from 'xml2js';
import childProcess from 'child_process';

/* eslint-disable no-underscore-dangle */

const isNumeric = n =>
  !isNaN(parseFloat(n)) && isFinite(n);

const ignoredNumbericKeys = ['formatLevel', 'chromasubsampling'];

const mapValue = (value, key) => {
  const ret = Array.isArray(value) ? value[0] : value;
  return isNumeric(ret) && !ignoredNumbericKeys.includes(key) ? ret * 1 : ret;
};

const transformResponse = (res) => {
  /* eslint-disable no-param-reassign */
  const regex = /^([0-9]+)\.[0-9]+(\.[0-9]+)?$/;
  let major = 0;
  if (res.creatinglibrary
    && res.creatinglibrary._version
    && regex.test(res.creatinglibrary._version)) {
    const [, majorStr] = res.creatinglibrary._version.match(regex);
    major = parseInt(majorStr, 10);
  }
  const legacyFormat = major < 17;
  if (res && res.media && !legacyFormat) {
    res.file = res.media;
    delete res.media;
  }
  if (res && res.file) {
    const tracks = Array.isArray(res.file.track) ? res.file.track : [res.file.track];
    res.file.track = tracks.map(track => mapValues(track, mapValue));
  }
  return res;
};

export default function parse(buffer, callback = () => {}) {
  xmlParseString(buffer, {
    attrNameProcessors: [name => `_${name}`],
    explicitArray: false,
    explicitRoot: false,
    mergeAttrs: true,
    normalizeTags: true,
    tagNameProcessors: [camelCase]
  }, (err, obj) => {
    if (err) {
      callback(err);
      return;
    }
    callback(null, transformResponse(obj));
  });
}

function exec(mediaPath, callback = () => {}) {
  const mediainfo = childProcess.spawn('mediainfo', ['--Full', '--Output=XML', mediaPath]);
  let output = '';
  mediainfo.stdout.on('data', (data) => { output += data.toString('utf8'); });
  mediainfo.on('close', () => parse(output, callback));
}

export {parse, exec};
